import { useEffect, useState } from "react";
import DataItem from "../../models/DataItem";
import FlexRow from "../base/FlexRow";


interface IProps {
    id?: string
    name?: string
    checked?: boolean
    label?: string
    className?: string
    source?: DataItem[]
    value?: any
    onChange?: (e: boolean) => void
}
export default function RadioButtonList(props: IProps) {

    const [value, valueSet] = useState<string>()

    useEffect(() => {
        valueSet(props.value)
    }, [props.value])

    return (
        <FlexRow className="mb-5">

            {
                props.source?.map(src =>
                    <label className={`btn btn-outline btn-outline-dashed btn-active-light-primary d-flex flex-stack text-start px-6 me-3 ${value == src.id ? "active" : ""}`}>
                        <div className="d-flex align-items-center">
                            <div className="form-check form-check-custom form-check-sm form-check-solid form-check-primary me-3">
                                <input className="form-check-input" type="radio" checked={value == src.id}
                                    onChange={e => {
                                        if (e.target.checked) valueSet(src.id)
                                    }} />
                            </div>
                            <div className="flex-grow-1">
                                <div className="fs-6">
                                    {src.name}
                                </div>
                            </div>
                        </div>
                    </label>
                )
            }

            <input type="hidden" name={props.name} value={value} />

        </FlexRow>
    )
}